<template>
  <div class="dashboard">
    <sui-segment>
      <h3>Production Units</h3>
      <p>Production units are isolated cloud broadcast production environments.</p>
    </sui-segment>
    <sui-segments>
      <sui-segment :loading="loadingProductionUnits" v-if="loadingProductionUnits"><br><br><br><br></sui-segment>
      <sui-segment v-for="productionUnit of productionUnits" :key="productionUnit.id">
        <router-link :to="{ name: 'productionUnit', params: { id: productionUnit.id } }" class="production-unit-link">{{productionUnit.name}}</router-link>
        <p>{{ productionUnit.description }}</p>
      </sui-segment>
    </sui-segments>
  </div>
</template>

<script>
import productionUnitsService from './../services/production-units';

export default {
  name: "dashboard",
  components: {},
  data () {
    return {
      loadingProductionUnits: null,
      productionUnits: null
    }
  },
  mounted () {
    this.getProductionUnits().then(() => this.loadingProductionUnits = false).catch(() => {
      this.loading = false;
    });
  },
  methods: {
    async getProductionUnits () {
      this.loadingProductionUnits = true;
      this.productionUnits = await productionUnitsService.getProductionUnits();
    }
  }
};
</script>

<style lang="scss" scoped>
h3{
  margin-bottom: 5px;
}
.production-unit-link{
  font-size: 18px !important;
  font-weight:500;
}
</style>